import { jsx as r } from "react/jsx-runtime";
import { forwardRef as pe, useRef as C, useState as R, useEffect as fe } from "react";
import { useTranslation as me } from "react-i18next";
import B from "classnames";
import we, { Option as U } from "rc-select";
import he from "../FieldContainer/index.js";
import be from "../../helpers/nanoid.js";
import ge from "./hooks/useDropdownWidth.js";
import _e from "./hooks/useLoadingOptions.js";
import { menuItemSelectedIcon as ve, suffixIcon as ye, maxTagPlaceholder as Ce, builtinPlacements as Re, optionRender as Se, dropdownRender as Ee, getSelectMode as Ie } from "./elements/index.js";
const Ne = "forma-ui__select__input", Pe = "forma-ui__select__readonly", xe = "forma-ui__select__secondary", i = {
  input: Ne,
  readonly: Pe,
  secondary: xe
}, Ue = pe(({
  id: w = be(8),
  name: j,
  onChange: S,
  onFocus: E,
  onBlur: I,
  hidden: $,
  className: H,
  disabled: K,
  placeholder: l,
  readOnly: h,
  meta: n = {},
  viewStyle: N = "primary",
  multiple: a,
  options: b = [],
  defaultValue: V,
  value: c,
  ...P
}, g) => {
  const {
    showArrow: q = !0,
    creatable: d,
    loadingUrl: u,
    loadingMethod: z,
    loadingParam: G,
    loadingMapper: J,
    dropdownWidth: Q,
    dropdownClassName: X,
    afterDropdownButton: Y,
    notFoundMessage: x,
    showClearButton: Z,
    customLabelKey: ee,
    showTags: L
  } = n, T = Ie({ creatable: d, multiple: a, readOnly: h, loadingUrl: u }), { t: _ } = me(), oe = g && "current" in g ? g : C(null), M = C(null), v = C(null), { loadedOptions: p, isLoading: D, loadOptions: te } = _e({ loadingUrl: u, loadingMethod: z, loadingParam: G, loadingMapper: J }), { dropdownMatchSelectWidth: O } = ge({ dropdownWidth: Q, containerRef: M }), [A, ne] = R(null), [se, F] = R(!1), [re, f] = R(!1);
  fe(() => {
    W(), document.dispatchEvent(new Event("selectUpdate", { bubbles: !0 }));
  }, [b, p]);
  const W = () => {
    setTimeout(() => {
      var e, t;
      if (v.current) {
        const o = (t = (e = v.current) == null ? void 0 : e.closest(".rc-select-dropdown")) == null ? void 0 : t.classList.value;
        ["topLeft", "topRight", "bottomLeft", "bottomRight"].forEach((s) => {
          o != null && o.match(s) && ne(s);
        });
      }
    }, 100);
  }, ce = (e, t) => {
    let o = Array.isArray(e) ? e.join(",") : e;
    S && S({ target: { name: j, value: o } }, t.data), u && te(o);
  }, ie = (e) => {
    E && E(e), W(), F(!0), document.dispatchEvent(new Event("selectOpen", { bubbles: !0 }));
  }, le = (e) => {
    I && I(e), F(!1), f(!1), document.dispatchEvent(new Event("selectClose", { bubbles: !0 }));
  };
  let y = /* @__PURE__ */ r("span", { children: _("uikit:empty") });
  T === "combobox" && (!c || D ? y = null : x && (y = /* @__PURE__ */ r("div", { onMouseUp: () => f(!1), children: x }))), l || (d ? l = _("uikit:enter_value") : l = _("uikit:select_value"));
  const ae = !h && (!!u || d), k = typeof O == "number", de = L ? 5 : 1, ue = (e) => e.closest(".fill-document-content") ?? e.closest(".modal__content") ?? document.body;
  return /* @__PURE__ */ r(
    he,
    {
      id: w,
      hidden: $,
      ...P,
      ...n,
      isShowTooltip: se,
      ref: M,
      children: /* @__PURE__ */ r(
        we,
        {
          id: w,
          open: re,
          onDropdownVisibleChange: f,
          onChange: ce,
          onFocus: ie,
          onBlur: le,
          className: B(
            `rc-select_${w}`,
            i.input,
            i[N],
            H,
            n.icon && i.withIcon,
            n.error && "error",
            n.success && "success",
            k && "rc-select-wide",
            A && `rc-select-${A}`,
            d && "rc-select-creatable",
            L && "rc-select-tags",
            h && i.readonly
          ),
          placeholder: l,
          mode: T,
          disabled: K,
          allowClear: Z,
          optionLabelProp: ee,
          menuItemSelectedIcon: ({ isSelected: e }) => ve(e, a),
          suffixIcon: ({ loading: e }) => ye(e, q, n.icon),
          loading: D,
          removeIcon: null,
          notFoundContent: y,
          maxTagPlaceholder: Ce,
          maxTagCount: de,
          listHeight: 290,
          dropdownAlign: { offset: [0, 4] },
          dropdownMatchSelectWidth: O,
          builtinPlacements: Re,
          dropdownClassName: B(
            X,
            i[N],
            a && "rc-select-dropdown-multiple",
            k && "rc-select-dropdown-wide"
          ),
          showSearch: ae,
          optionRender: (e) => Se(e, b, p, c),
          dropdownRender: (e) => Ee(e, v, Y, () => f(!1)),
          getPopupContainer: ue,
          virtual: !1,
          defaultValue: V,
          value: a && c ? c.split(",") : c || void 0,
          ref: oe,
          ...P,
          children: p ? (
            // data attribute returns object, but it need for backward compatibility options list params
            p.map(({ label: e, value: t, className: o, data: m }, s) => /* @__PURE__ */ r(U, { className: o, value: t, data: m, children: e }, s))
          ) : b.map(({ label: e, value: t, className: o, displayLabel: m }, s) => /* @__PURE__ */ r(U, { className: o, value: t, displayLabel: m, children: e }, s))
        }
      )
    }
  );
});
export {
  Ue as default,
  _e as useLoadingOptions
};
